
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 16.052a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm6.25 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-12.5 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm20.663-5.425a14.006 14.006 0 00-3.01-4.478 13.886 13.886 0 00-4.478-3.01A13.934 13.934 0 0016 2.053h-.062a13.967 13.967 0 00-9.891 4.137 13.873 13.873 0 00-2.975 4.463A14.005 14.005 0 002 16.118c.01 2.17.524 4.308 1.5 6.247v4.75a1.438 1.438 0 001.438 1.437H9.69a14.043 14.043 0 006.247 1.5h.065c1.872 0 3.688-.363 5.397-1.072a13.889 13.889 0 004.463-2.975A13.968 13.968 0 0030 16.115c.01-1.904-.36-3.75-1.087-5.488zM24.19 24.314A11.563 11.563 0 0116 27.677h-.054a11.666 11.666 0 01-5.41-1.36l-.262-.14h-4.4v-4.4l-.14-.262a11.666 11.666 0 01-1.36-5.41 11.553 11.553 0 013.363-8.244 11.538 11.538 0 018.212-3.434h.053c1.563 0 3.078.303 4.507.903a11.55 11.55 0 013.718 2.5 11.567 11.567 0 012.5 3.719c.607 1.444.91 2.975.903 4.556a11.58 11.58 0 01-3.44 8.21z"}})])
          )
        }
      }
    